// Portabilite.vue

<template>
  <v-container>
    <v-row>
      <v-col cols="8">
        <h1>Récapitulatif des informations client</h1>
      </v-col>
      <v-col cols="4" class="text-right">
        <v-btn v-if="!fromPendingList" to="/souscription/offresbox/eligibilite/choixoffreoption">Retour</v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>

 <v-form>
  <v-row justify="center">
    <v-col cols="12" sm="10">
      <v-card>
        <v-card-title class="headline">
          Titulaire du contrat
        </v-card-title>
        <v-card-text>
          <v-row v-if="modifCivilite">
            <v-col cols="12" sm="6">
              <v-select
                label="Civilité" 
                dense 
                outlined
                v-model="factCivilite"
                hide-details="yes"
                :items="itemsCivilite"
                item-text="code"
                item-value="valeur"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field 
                label="Nom" 
                readonly 
                dense 
                filled 
                v-model="factNom"
                hide-details="yes"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field 
                label="Prénom" 
                readonly 
                dense 
                filled 
                v-model="factPrenom"
                hide-details="yes"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field 
                label="Date de naissance" 
                readonly 
                dense 
                filled 
                v-model="factDateNaissance"
                hide-details="yes"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <v-row justify="center" v-if="pieceIban">
    <v-col cols="12" sm="10">
      <v-card>
        <v-card-title class="headline">
          Relevé d'identité bancaire
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field 
                label="Nom" 
                readonly 
                dense 
                filled 
                v-model="factNomIban"
                hide-details="yes"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field 
                label="Prénom" 
                readonly 
                dense 
                filled 
                v-model="factPrenomIban"
                hide-details="yes"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row >
            <v-col cols="12" sm="12">
              <v-text-field 
                label="IBAN" 
                :readonly="!modifIban" 
                dense 
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                 maxlength="27"
                :outlined="modifIban"
                :filled="!modifIban" 
                :clearable="modifIban"
                hide-details="auto"
                v-model="factIban"
                required
                :error-messages="ibanErrors"
                @input="$v.factIban.$touch()"
                @blur="$v.factIban.$touch()"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12" sm="6">
              <v-text-field 
                label="BIC" 
                readonly 
                dense 
                filled 
                v-model="factBic"
                hide-details="yes"
              ></v-text-field>
            </v-col>
          </v-row> -->
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <v-row justify="center">
    <v-col cols="12" sm="10">
      <v-card>
        <v-card-title class="headline">
          Adresse de facturation
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12">
              <v-text-field 
                label="Adresse" 
                :outlined="modifAdresse" 
                dense 
                hide-details="auto" 
                v-model="factAdresse"
                maxlength="60"
                clearable
                required
                :filled="!modifAdresse" 
                :readonly="!modifAdresse" 
                :error-messages="adresseErrors"
                @input="$v.factAdresse.$touch()"
                @blur="$v.factAdresse.$touch()"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12">
              <v-text-field 
                label="Complément d'adresse" 
                :outlined="modifAdresse"  
                dense 
                hide-details="auto" 
                v-model="factComplAdresse"
                maxlength="60"
                clearable
                :filled="!modifAdresse"
                :readonly="!modifAdresse" 
                :error-messages="complAdresseErrors"
                @input="$v.factComplAdresse.$touch()"
                @blur="$v.factComplAdresse.$touch()"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field 
                label="Code postal" 
                :outlined="modifAdresse"  
                dense 
                hide-details="auto" 
                v-model="factCodePostal"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                type="number"
                maxlength="5"
                clearable
                required
                :filled="!modifAdresse"
                :readonly="!modifAdresse" 
                :error-messages="codePostalErrors"
                @input="$v.factCodePostal.$touch()"
                @blur="$v.factCodePostal.$touch()"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field 
                label="Ville" 
                :outlined="modifAdresse"  
                dense 
                hide-details="auto" 
                v-model="factVille"
                maxlength="30"
                clearable
                required
                :filled="!modifAdresse"
                :readonly="!modifAdresse" 
                :error-messages="villeErrors"
                @input="$v.factVille.$touch()"
                @blur="$v.factVille.$touch()"
                ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <v-row justify="center">
    <v-col cols="12" sm="10">
      <v-card>
        <v-card-title class="headline">
          Informations de contact
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12">
              <!--<v-text-field 
                label="Adresse e-mail" 
                :outlined="modifEmail"  
                dense 
                hide-details="auto"
                v-model="contactEmail"
                clearable
                required
                :filled="!modifEmail"
                :readonly="!modifEmail" 
                :error-messages="errorEmail"
                @input="isValidEmail()"
                :loading="loadingEmail"
                
                >
                <template v-slot:progress>
                    <v-progress-circular                    
                      :size="25"
                      :width="2"
                    color="red"
                    indeterminate
                  ></v-progress-circular>
                </template>
              </v-text-field>-->
              <v-text-field 
                label="Adresse e-mail" 
                :outlined="modifEmail"  
                dense 
                hide-details="auto"
                v-model="contactEmail"
                clearable
                required
                :filled="!modifEmail"
                :readonly="!modifEmail" 
                :error-messages="emailErrors"
                @input="$v.contactEmail.$touch()"
                @blur="$v.contactEmail.$touch()"
                >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field 
              label="Téléphone mobile" 
              :outlined="modifNumMobile"   
              dense 
              hide-details="auto"
              v-model="contactNumMobile"
              maxlength="10"
              clearable
              type="tel"
              :filled="!modifNumMobile"
              :readonly="!modifNumMobile" 
              :error-messages="mobileErrors"
              :counter="10"
              @input="sanitizePhone"
              @blur="$v.contactNumMobile.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field 
              label="Téléphone fixe" 
              :outlined="modifNumFixe"   
              dense 
              hide-details="auto"
              v-model="contactNumFixe"
              maxlength="10"
              clearable
              type="number"
              :filled="!modifNumFixe"
              :readonly="!modifNumFixe" 
              :error-messages="fixeErrors"
              :counter="10"
              @input="$v.contactNumFixe.$touch()"
              @blur="$v.contactNumFixe.$touch()"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  
    <br />
    <v-divider></v-divider>

    <v-row >
      <v-spacer></v-spacer>
      <v-col cols="4" class="text-right">
        <v-btn class="poursuivre" :loading="loading" @click="validationinfosContact()">Poursuivre</v-btn>
      </v-col>
    </v-row>
 </v-form>
  </v-container>
</template>
<script>
import {DoccliService} from '../../../../providers/DoccliService.js';
const doccliService = new DoccliService();
import {ContratService} from '../../../../providers/ContratService.js';
import { required, minLength,maxLength,email,helpers } from 'vuelidate/lib/validators'
const alpha = helpers.regex('alpha', /^97[1-6][0-9]{2}$/);
const mobileRegex = helpers.regex('mobileRegex', /^(0[679]\d{8})$/);


const contratService = new ContratService();
export default {
  data() {
    return {  
      loading:false,
      loadingEmail:false,
      infoTitulaire:null,
      infoHebergeur:null,
      infoTiersPayeur:null,
      infoIban:null,
      infoJustifDom:null,
      factCivilite:null,
      itemsCivilite: [
        { code: 'Madame', valeur: 'f'},
        { code: 'Monsieur', valeur: 'm'},
      ],
      factNom:null,
      factPrenom:null,
      factDateNaissance:null,
      factIban:null,
      factNomIban:null,
      factPrenomIban:null,
      factBic:null,
      factAdresse:null,
      factComplAdresse:null,
      factCodePostal:null,
      factVille:null,
      contactEmail:null,
      contactNumFixe: null,
      contactNumMobile: null,
      titulaire:null,
      fromPendingList:false,
      modifCivilite:true,
      modifIban:false,
      modifAdresse:true,
      modifEmail:true,
      modifNumFixe:true,
      modifNumMobile:true,
      errorEmail:"",      
    pieceIban: false
    };
  },
  validations: function (){
    if(this.pieceIban) {
      return {
        factIban: { required,minLength: minLength(27), maxLength: maxLength(27) },
        factAdresse: { required,maxLength: maxLength(60) },
        factComplAdresse: { maxLength: maxLength(60) },
        factCodePostal: { required, minLength: minLength(5),maxLength: maxLength(5), alpha },
        factVille: { required,maxLength: maxLength(30) },
        contactNumMobile: { required, minLength: minLength(10),maxLength: maxLength(10),mobileRegex  },
        contactNumFixe: { minLength: minLength(10),maxLength: maxLength(10) },
        contactEmail: { required, email }
      }
    }else{
      return {
        factAdresse: { required,maxLength: maxLength(60) },
        factComplAdresse: { maxLength: maxLength(60) },
        factCodePostal: { required, minLength: minLength(5),maxLength: maxLength(5), alpha },
        factVille: { required,maxLength: maxLength(30) },
        contactNumMobile: { required, minLength: minLength(10),maxLength: maxLength(10), mobileRegex },
        contactNumFixe: { minLength: minLength(10),maxLength: maxLength(10) },
        contactEmail: { required, email }
      }
    }
    
  },
  computed: {
    mobileErrors () {
      const errors = []
      if (!this.$v.contactNumMobile.$dirty) return errors
      !this.$v.contactNumMobile.maxLength && errors.push('Numero à 10 chiffres')
      !this.$v.contactNumMobile.minLength && errors.push('Numero à 10 chiffres')
      !this.$v.contactNumMobile.required && errors.push('Numéro obligatoire.')
      !this.$v.contactNumMobile.mobileRegex && errors.push('Numéro invalide (Métropole ou DOM uniquement).');
            return errors
    },
    fixeErrors () {
      const errors = []
      if (!this.$v.contactNumFixe.$dirty) return errors
      !this.$v.contactNumFixe.maxLength && errors.push('Numero à 10 chiffres')      
      !this.$v.contactNumFixe.minLength && errors.push('Numero à 10 chiffres')
      return errors
    },
    emailErrors () {
      const errors = []
      //this.errorEmail="";
      if (!this.$v.contactEmail.$dirty) return errors
      !this.$v.contactEmail.email && errors.push('Adresse email invalide')
      !this.$v.contactEmail.required && errors.push('Adresse email obligatoire')
      //if(this.errorEmail != '') errors.push(this.errorEmail)
      return errors
    },
    ibanErrors () {
      const errors = []
      if (!this.$v.factIban.$dirty) return errors
      !this.$v.factIban.minLength && errors.push('Iban incorrect')
      !this.$v.factIban.maxLength && errors.push('Iban incorrect')
      !this.$v.factIban.required && errors.push('Iban obligatoire')
      return errors
    },
    adresseErrors () {
      const errors = []
      if (!this.$v.factAdresse.$dirty) return errors
      !this.$v.factAdresse.maxLength && errors.push('38 caractères maximum autorisés')
      !this.$v.factAdresse.required && errors.push('Adresse obligatoire')
      return errors
    },
    complAdresseErrors () {
      const errors = []
      if (!this.$v.factComplAdresse.$dirty) return errors
      !this.$v.factComplAdresse.maxLength && errors.push('38 caractères maximum autorisés')
      return errors
    },
    codePostalErrors () {
      const errors = []
      if (!this.$v.factCodePostal.$dirty) return errors
      !this.$v.factCodePostal.required && errors.push('Code postal obligatoire')
      !this.$v.factCodePostal.maxLength && errors.push('Code postal à 5 chiffres')      
      !this.$v.factCodePostal.minLength && errors.push('Code postal à 5 chiffres')
      !this.$v.factCodePostal.alpha && errors.push('Le code postal doit commencer par 971, 972, 973 974 ou 976')
      return errors
    },
    villeErrors () {
      const errors = []
      if (!this.$v.factVille.$dirty) return errors
      !this.$v.factVille.maxLength && errors.push('30 caractères maximum autorisés')
      !this.$v.factVille.required && errors.push('Ville obligatoire')
      return errors
    }
  },
  mounted: async function () {
    //console.log("entree contact")
    this.initFromSession();
   
  },
  beforeMount: function(){
     if(this.$globalService.getSessionSouscription().fromPendingList)
          this.fromPendingList = true;
  },
  methods: {
    sanitizePhone() {
      // Supprime les caractères non numériques
      this.contactNumMobile = this.contactNumMobile.replace(/\D/g, "").slice(0, 10);
    },
    isValidEmail: async function (){
      this.errorEmail = "";
      if (!this.contactEmail){
        this.errorEmail = 'Adresse email obligatoire';
        return false;
      }

          this.loadingEmail = true;
          this.loading = true;
          await contratService.checkEmail(this.contactEmail).then(res => {          
            this.loadingEmail = false;
            this.loading = false;
          if (res) {
            if (res.err != "error") {
              let isValid =   typeof res.params.code !== "undefined" && res.params.code === 0;
              if(!isValid){
                this.errorEmail =  'Adresse email invalide';
                return false;
              }else{
                this.errorEmail =  "";
                return true;
              }
            }else{
              this.errorEmail =  "";  
              return true;      
            }
          }
        })
        .catch(() => {
          this.loadingEmail = false;
          this.loading = false;
          this.errorEmail =  "";
          return true;
        });



    },
    setScanFinish:function(doccli_id){
      
      this.loading = true;
      doccliService.setScanFinish(doccli_id).then(res => {  
        console.log(res);      
           this.loading = false;
         
        })
        
      
    },
    initFromSession: function () {

      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(sessionSouscription == null || sessionSouscription.resultDossierScan == null || sessionSouscription.resultDossierScan.fullDocuments == null){
          this.$dialog.notify.error(this.$root.errorMessage, {
                    position: 'bottom-right',
                    timeout: 5000
                  })
          return;

      } else{
        

          this.setScanFinish(sessionSouscription.doccli_id);

        
          //
          this.pieceIban = Array.isArray(sessionSouscription.piecesToScan) && sessionSouscription.piecesToScan.includes('IBAN');

        const documents = sessionSouscription.resultDossierScan.fullDocuments;
        for (var item in documents) {
          if(documents[item].refDoc == 'IDENT_PRIN')
            this.infoTitulaire = documents[item];
          if(documents[item].refDoc == 'IDENT_HEBERG')
            this.infoHebergeur = documents[item];
          if(documents[item].refDoc == 'IDENT_TIERS')
            this.infoTiersPayeur = documents[item];
          if(documents[item].refDoc == 'IBAN')
            this.infoIban = documents[item];
          if(documents[item].refDoc == 'JUSTIF_DOM')
            this.infoJustifDom = documents[item];
        }

        if(this.fromPendingList) {  // reprise de contrats en attente ... pas de modif car le contrat a deja ete enregistré

          this.factNom = this.infoTitulaire.persons.identityData.lastName.value;
          this.factPrenom = this.infoTitulaire.persons.identityData.firstNames.value;
          this.factDateNaissance = this.infoTitulaire.persons.identityData.birthDate.value;

          this.factCivilite = sessionSouscription.factCivilite;
          if(this.pieceIban ){
            this.factNomIban = sessionSouscription.factNomIban;
            this.factPrenomIban = sessionSouscription.factPrenomIban;
            this.factIban = sessionSouscription.factIban;          
            this.modifIban = false;
          }
          this.factBic = sessionSouscription.factBic;
          this.factAdresse = sessionSouscription.factAdresse;
          this.factComplAdresse = sessionSouscription.factComplAdresse;
          this.factCodePostal = sessionSouscription.factCodePostal;
          this.factVille = sessionSouscription.factVille;
          this.contactEmail = sessionSouscription.contactEmail;
          this.contactNumFixe = sessionSouscription.contactNumFixe;
          this.contactNumMobile = sessionSouscription.contactNumMobile;
          this.modifCivilite = false;
          this.modifAdresse = false;
          this.modifEmail = false;
          this.modifNumFixe = false;
          this.modifNumMobile = false;
          
        } else {  // 1ere souscription

          // Titulaire
          if(this.infoTitulaire && this.infoTitulaire.persons && this.infoTitulaire.persons.identityData){

            if(this.infoTitulaire.persons.identityData.gender && this.infoTitulaire.persons.identityData.gender.value) {
              this.factCivilite = this.infoTitulaire.persons.identityData.gender.value;
              this.modifCivilite = false;
            } else {
              this.modifCivilite = true;
            }

            this.factNom = this.infoTitulaire.persons.identityData.lastName.value;
            this.factPrenom = this.infoTitulaire.persons.identityData.firstNames.value;
            this.factDateNaissance = this.infoTitulaire.persons.identityData.birthDate.value;
          } else {
            this.$dialog.notify.error("Erreur : Donnees titulaire manquantes", {
                      position: 'bottom-right',
                      timeout: 5000
                    })
            return;
          }

          //Iban
          if(this.infoIban && this.infoIban.persons && this.infoIban.persons.financeData && this.infoIban.persons.financeData && this.infoIban.persons.financeData.iban && this.infoIban.persons.financeData.iban.value && this.infoIban.persons.financeData.iban.value.length == 27) {
            this.factIban = this.infoIban.persons.financeData.iban.value;
            this.factBic = this.infoIban.persons.financeData.bic.value;
            this.modifIban = false;
          } else {  //Iban non extrait du scan ou invalide donc on peut le renseigner manuellement
            this.factBic = "";
            this.modifIban = true;
            if(!this.pieceIban ){
              this.factIban = '';
            }
          }
          if(sessionSouscription.existTiersPayeur == 1) {
            this.factNomIban = this.infoTiersPayeur.persons.identityData.lastName.value;
            this.factPrenomIban = this.infoTiersPayeur.persons.identityData.firstNames.value;
          } else {
            this.factNomIban = this.infoTitulaire.persons.identityData.lastName.value;
            this.factPrenomIban = this.infoTitulaire.persons.identityData.firstNames.value;
          }

          //Adresse
          if(this.infoJustifDom && this.infoJustifDom.persons && this.infoJustifDom.persons.addressData){ // infos extraites du scan
            this.factAdresse = (this.infoJustifDom.persons.addressData.lane && this.infoJustifDom.persons.addressData.lane.value ? this.infoJustifDom.persons.addressData.lane.value : "");
            this.factCodePostal = (this.infoJustifDom.persons.addressData.zipCode && this.infoJustifDom.persons.addressData.zipCode.value ? this.infoJustifDom.persons.addressData.zipCode.value : "");
            this.factVille = (this.infoJustifDom.persons.addressData.city && this.infoJustifDom.persons.addressData.city.value ? this.infoJustifDom.persons.addressData.city.value : "" );
          } else {  // pas d'infos adresse extraites du scan, on pré-rempli avec l'adresse d'éligibilité
            this.factAdresse = sessionSouscription.eligibilite.adresse.numrue +' '+ sessionSouscription.eligibilite.adresse.rue;
            this.factComplAdresse = (sessionSouscription.eligibilite.adresse.complement_numero_voie) ? sessionSouscription.eligibilite.adresse.complement_numero_voie: "";
            this.factCodePostal = sessionSouscription.eligibilite.adresse.codepostal;
            this.factVille = sessionSouscription.eligibilite.adresse.ville;
          }

        }

      }

    },
    validationinfosContact: async function () {
      this.$v.$touch();
    /*
      if (this.$v.$invalid || !this.contactEmail || this.errorEmail != '' ) {
          if(!this.contactEmail)
            this.errorEmail = "Adresse email obligatoire";
          if(!this.$v.contactEmail.email) 
            this.errorEmail = 'Adresse email invalide';
           */
      if (this.$v.$invalid ){  
         this.$dialog.warning({
          text: "Veuillez vérifier votre saisie",
          title: "Attention",
          persistent: false,
          actions: {
            false: "Fermer",
          },
        });
        return;
      } else {  
        await this.isValidEmail();
        if(this.errorEmail !=""){
          this.$dialog.warning({
            text: this.errorEmail,
            title: "Attention",
            persistent: false,
            actions: {
              false: "Fermer",
            },
          });
          return;
        } else{
          this.loading = true;
          
              //creation du contrat
            var sessionSouscription = this.$globalService.getSessionSouscription();
            if(sessionSouscription == null || sessionSouscription.resultDossierScan == null || sessionSouscription.resultDossierScan.fullDocuments == null){
                this.loading = false;
                this.$dialog.notify.error(this.$root.errorMessage, {
                          position: 'bottom-right',
                          timeout: 5000
                        })
                return;
            }



          const site = this.$root.user.site;
          const domaine = this.$root.user.domaine;
          const codevendeur = this.$root.user.codevendeur;
          if(this.infoTitulaire && this.infoTitulaire.persons && this.infoTitulaire.persons.identityData){
            //var civilite = this.infoTitulaire.persons.identityData.gender.value;
            var nom = this.infoTitulaire.persons.identityData.lastName.value;
            var prenom = this.infoTitulaire.persons.identityData.firstNames.value;
            var dateNaissance = this.infoTitulaire.persons.identityData.birthDate.value;
            var typedocIdent = this.infoTitulaire.info.documentType.value;
            var iddocIdent = this.infoTitulaire.info.documentNumber.value;

            this.titulaire = { nom: nom, prenom: prenom, dateNaissance:dateNaissance, typedocIdent: typedocIdent, iddocIdent:iddocIdent };
            this.$globalService.setSessionSouscription('titulaire',this.titulaire);
          }else{
            this.loading = false;
                this.$dialog.notify.error("Erreur : donnees titulaire manquantes", {
                          position: 'bottom-right',
                          timeout: 5000
                        })
                return;
          }

          var adresse = this.factAdresse;
          var adresseComplement = this.factComplAdresse;
          var codePostal = this.factCodePostal;
          var ville = this.factVille;

          var contactMail = this.contactEmail;

          var civilite = this.factCivilite;
          var iban = this.factIban;
          var bic = this.factBic;

          var idOffre = sessionSouscription.offreChoisie.id;
          var latitude = sessionSouscription.eligibilite.lat;
          var longitude = sessionSouscription.eligibilite.lon;

          if(sessionSouscription.serviceChoisi ){
            var serviceType = sessionSouscription.serviceChoisi.type;

            // variables FIBRE
            var infrastructure = (serviceType=='ftth' ? sessionSouscription.serviceChoisi.infra : '');
            var referenceAdresse = (serviceType=='ftth' ? sessionSouscription.serviceChoisi.ref_adresse : '');
            //var referenceImmeuble = (serviceType=='ftth' ? sessionSouscription.serviceChoisi.ref_immeuble : '');
            var referencePm = (serviceType=='ftth' ? sessionSouscription.serviceChoisi.reference_pm : '');
            var fibre_numeroRue = (serviceType=='ftth' ? sessionSouscription.serviceChoisi.adresse_beb.numero_de_voie : '');
            var fibre_typeVoie = (serviceType=='ftth' ? sessionSouscription.serviceChoisi.adresse_beb.type_de_voie : '');
            var fibre_rue = (serviceType=='ftth' ? sessionSouscription.serviceChoisi.adresse_beb.libelle_voie : '');
            var fibre_complementRue = (serviceType=='ftth' ? sessionSouscription.serviceChoisi.adresse_beb.complement_numero_voie : '');
            var fibre_ville = (serviceType=='ftth' ? sessionSouscription.serviceChoisi.adresse_beb.libelle_commune : '');
            var fibre_codePostal = (serviceType=='ftth' ? sessionSouscription.serviceChoisi.adresse_beb.code_postal : '');
            var fibre_codeInsee = (serviceType=='ftth' ? sessionSouscription.serviceChoisi.adresse_beb.code_insee : '');
            var fibre_dateacceptation = (serviceType=='ftth' ? sessionSouscription.serviceChoisi.date_acceptation : '');
            var fibre_dateouverture = (serviceType=='ftth' ? sessionSouscription.serviceChoisi.date_ouverture : '');
            var fibre_datecommercialisation = (serviceType=='ftth' ? sessionSouscription.serviceChoisi.date_commercialisation : '');

            //variables CABLE

            // variable WTTX
            var wttx_cohesionNumerique = (serviceType=='wttx' ? sessionSouscription.serviceChoisi.cohesion_num : '');
            var wttx_attCohesionNumerique = (serviceType=='wttx' ? sessionSouscription.attCohesionNumerique : '');

          }else{
            this.loading = false;
                this.$dialog.notify.error(this.$root.errorMessage, {
                          position: 'bottom-right',
                          timeout: 5000
                        })
                return;
          }

          if(sessionSouscription.adrTech) {
            // variables FIBRE
            var referencePrise = (serviceType=='ftth' 
            && sessionSouscription.adrTech.immeuble && sessionSouscription.adrTech.immeuble.type && sessionSouscription.adrTech.immeuble.type == 'PAVILLON'
            && sessionSouscription.adrTech.prises && Array.isArray(sessionSouscription.adrTech.prises) && sessionSouscription.adrTech.prises.length > 0 && sessionSouscription.adrTech.prises[0].reference ? sessionSouscription.adrTech.prises[0].reference : ""); 
         
            var infoBatiment = (serviceType=='ftth' && sessionSouscription.adrTech.batiment ? sessionSouscription.adrTech.batiment : "");
            var infoEscalier = (serviceType=='ftth' && sessionSouscription.adrTech.escalier ? sessionSouscription.adrTech.escalier : "");
            var infoEtage = (serviceType=='ftth' && sessionSouscription.adrTech.etage ? sessionSouscription.adrTech.etage : "");
            var referenceImmeuble = (serviceType=='ftth' && sessionSouscription.adrTech.immeuble && sessionSouscription.adrTech.immeuble.reference ? sessionSouscription.adrTech.immeuble.reference : "");

            //variables CABLE
            var cable_referencePrise = (serviceType=='cable' && sessionSouscription.adrTech.ref_prise ? sessionSouscription.adrTech.ref_prise : ""); 
            var cable_numeroVoie = (serviceType=='cable' && sessionSouscription.adrTech.numero_voie ? sessionSouscription.adrTech.numero_voie : "");
            var cable_voie = (serviceType=='cable' && sessionSouscription.adrTech.voie ? sessionSouscription.adrTech.voie : "");
            var cable_complementVoie = (serviceType=='cable' && sessionSouscription.adrTech.complement_numero_voie ? sessionSouscription.adrTech.complement_numero_voie : "");
            var cable_batiment = (serviceType=='cable' && sessionSouscription.adrTech.batiment ? sessionSouscription.adrTech.batiment : "");
            var cable_escalier = (serviceType=='cable' && sessionSouscription.adrTech.escalier ? sessionSouscription.adrTech.escalier : "");
            var cable_etage = (serviceType=='cable' && sessionSouscription.adrTech.etage ? sessionSouscription.adrTech.etage : "");
            var cable_ville = (serviceType=='cable' && sessionSouscription.adrTech.ville ? sessionSouscription.adrTech.ville : "");
            var cable_codeRivoli = (serviceType=='cable' && sessionSouscription.adrTech.code_rivoli ? sessionSouscription.adrTech.code_rivoli : "");
            var cable_codePostal = (serviceType=='cable' && sessionSouscription.adrTech.code_postal ? sessionSouscription.adrTech.code_postal : "");
            var cable_codeInsee = (serviceType=='cable' && sessionSouscription.adrTech.code_insee ? sessionSouscription.adrTech.code_insee: "");
          }

          //infos GEOLOC
          var numeroRue =  sessionSouscription.eligibilite.adresse.numrue;        
          var infoRue = sessionSouscription.eligibilite.adresse.rue;
          var complementRue = sessionSouscription.eligibilite.adresse.complement_numero_voie;
          var infoVille = sessionSouscription.eligibilite.adresse.ville;
          var porte = (sessionSouscription.eligibilite.adresse.porte ? sessionSouscription.eligibilite.adresse.porte : null);
          var ensemble = (sessionSouscription.eligibilite.adresse.ensemble ? sessionSouscription.eligibilite.adresse.ensemble : null);
          var infoCodePostal = sessionSouscription.eligibilite.adresse.codepostal;
          var codeInsee = sessionSouscription.eligibilite.adresse.codeinsee;
          var id_eligibilite = sessionSouscription.eligibilite.id_eligibilite;
          var libelleAdresse = sessionSouscription.eligibilite.adresse.label;
          var contactMobile = this.contactNumMobile;
          var contactFixe = this.contactNumFixe;
          var listeIdOption = null;
          var optionsChoisies = null;
          if(sessionSouscription.optionsChoisies && sessionSouscription.optionsChoisies.length != 0 ){
            var optionsSelected = [];
            sessionSouscription.optionsChoisies.forEach(opt => {
              optionsSelected.push(opt.id);
            });
            listeIdOption = optionsSelected;
            optionsChoisies = sessionSouscription.optionsChoisies;
          } 
          var offreChoisie = sessionSouscription.offreChoisie;

          var numero = sessionSouscription.numFixe;
          var rio = sessionSouscription.codeRIO;
          
          
          var idMobile = (sessionSouscription.idMobile ? sessionSouscription.idMobile:null);
          var listeIdAccessoire = (sessionSouscription.listeIdAccessoire ? sessionSouscription.listeIdAccessoire:null);
          var doccli_id = (sessionSouscription.doccli_id ? sessionSouscription.doccli_id:null);
          var conservNum = (sessionSouscription.conservNum ? sessionSouscription.conservNum:null);
          var souscriptionId = (sessionSouscription.souscriptionId ? sessionSouscription.souscriptionId:null);
      
          var checkStatus = (sessionSouscription.resultCheckScan.checkStatus ? sessionSouscription.resultCheckScan.checkStatus : null);
          var opMkt = (sessionSouscription.opMkt ? sessionSouscription.opMkt : null);

          this.$globalService.setSessionSouscription('factCivilite',this.factCivilite);
          this.$globalService.setSessionSouscription('factNomIban',this.factNomIban);
          this.$globalService.setSessionSouscription('factPrenomIban',this.factPrenomIban);
          this.$globalService.setSessionSouscription('factIban',this.factIban);
          this.$globalService.setSessionSouscription('factAdresse',this.factAdresse);
          this.$globalService.setSessionSouscription('factComplAdresse',this.factComplAdresse);
          this.$globalService.setSessionSouscription('factCodePostal',this.factCodePostal);
          this.$globalService.setSessionSouscription('factVille',this.factVille);
          this.$globalService.setSessionSouscription('contactEmail',this.contactEmail);
          this.$globalService.setSessionSouscription('contactNumFixe',this.contactNumFixe);
          this.$globalService.setSessionSouscription('contactNumMobile',this.contactNumMobile);
          this.$globalService.setSessionSouscription('userType',this.$root.user.type);
          
          var codeDistributeur ="";
          if(this.$globalService.getSessionSouscription().codeDistributeur)
            codeDistributeur = this.$globalService.getSessionSouscription().codeDistributeur;
          else{
            if(this.$root.user.boutique)
              codeDistributeur = this.$root.user.boutique.code;
                        
            this.$globalService.setSessionSouscription('codeDistributeur',codeDistributeur);

          }

          var titulaireIban = this.factNomIban + ' ' + this.factPrenomIban;
          // check IBAN/BIC
          if(this.pieceIban ) {
            contratService.getBicFromIban(site, domaine, iban).then(res => {      // recuperation BIC
              this.loading = false;
              if(res){
                if (res.err !='error') {
                  this.$globalService.setUser(res.params.user);
                  const data = res.params;
                  bic = data.bic;
                  this.$globalService.setSessionSouscription('factBic',data.bic);

                  
                  // create contrat
                  var upd_session = this.$globalService.getSessionSouscription();
                  
                  this.createContrat(site,domaine,civilite,nom,prenom,dateNaissance,adresse, adresseComplement, codePostal,ville,contactMail,iban, bic,titulaireIban,idOffre,serviceType,latitude,longitude,infrastructure,referenceAdresse,referenceImmeuble,infoRue,infoBatiment,infoEscalier,infoEtage,infoVille,infoCodePostal,contactMobile, contactFixe,listeIdOption,numero,rio,referencePrise,numeroRue,complementRue,porte,ensemble,codeInsee,idMobile,listeIdAccessoire,doccli_id,conservNum,codevendeur,offreChoisie,optionsChoisies,souscriptionId,id_eligibilite,libelleAdresse,fibre_numeroRue,fibre_typeVoie,fibre_rue,fibre_complementRue,fibre_ville,fibre_codePostal,fibre_codeInsee,fibre_dateacceptation,fibre_dateouverture,fibre_datecommercialisation,cable_referencePrise,cable_numeroVoie,cable_voie,cable_complementVoie,cable_batiment,cable_escalier,cable_etage,cable_ville,cable_codeRivoli,cable_codePostal,cable_codeInsee,wttx_cohesionNumerique,wttx_attCohesionNumerique,typedocIdent,iddocIdent,checkStatus,opMkt,codeDistributeur,referencePm,upd_session);

                            
                }else{
                  this.$dialog.error({
                    text: res.err_msg,
                    title: 'Erreur',
                    persistent: false,
                    actions: {
                      false: 'Fermer'
                    }
                  })
                
                }
              }
            }).catch(error=>{
                this.loading = false;
                this.$dialog.notify.error(this.$root.errorMessage, {
                          position: 'bottom-right',
                          timeout: 5000
                        })
                return error;
            })
          }else{

            bic = '';
            iban = '';
            titulaireIban = '';
            this.$globalService.setSessionSouscription('factBic',bic);
            this.$globalService.setSessionSouscription('factIban',iban);

            
            // create contrat
            var upd_session = this.$globalService.getSessionSouscription();
            
            this.createContrat(site,domaine,civilite,nom,prenom,dateNaissance,adresse, adresseComplement, codePostal,ville,contactMail,iban, bic,titulaireIban,idOffre,serviceType,latitude,longitude,infrastructure,referenceAdresse,referenceImmeuble,infoRue,infoBatiment,infoEscalier,infoEtage,infoVille,infoCodePostal,contactMobile, contactFixe,listeIdOption,numero,rio,referencePrise,numeroRue,complementRue,porte,ensemble,codeInsee,idMobile,listeIdAccessoire,doccli_id,conservNum,codevendeur,offreChoisie,optionsChoisies,souscriptionId,id_eligibilite,libelleAdresse,fibre_numeroRue,fibre_typeVoie,fibre_rue,fibre_complementRue,fibre_ville,fibre_codePostal,fibre_codeInsee,fibre_dateacceptation,fibre_dateouverture,fibre_datecommercialisation,cable_referencePrise,cable_numeroVoie,cable_voie,cable_complementVoie,cable_batiment,cable_escalier,cable_etage,cable_ville,cable_codeRivoli,cable_codePostal,cable_codeInsee,wttx_cohesionNumerique,wttx_attCohesionNumerique,typedocIdent,iddocIdent,checkStatus,opMkt,codeDistributeur,referencePm,upd_session);

          }
          

        }
      }

    },
    createContrat: function(site,domaine,civilite,nom,prenom,dateNaissance,adresse, adresseComplement, codePostal,ville,contactMail,iban, bic,titulaireIban,idOffre,serviceType,latitude,longitude,infrastructure,referenceAdresse,referenceImmeuble,infoRue,infoBatiment,infoEscalier,infoEtage,infoVille,infoCodePostal,contactMobile, contactFixe,listeIdOption,numero,rio,referencePrise,numeroRue,complementRue,porte,ensemble,codeInsee,idMobile,listeIdAccessoire,doccli_id,conservNum,codevendeur,offreChoisie,optionsChoisies,souscriptionId,id_eligibilite,libelleAdresse,fibre_numeroRue,fibre_typeVoie,fibre_rue,fibre_complementRue,fibre_ville,fibre_codePostal,fibre_codeInsee,fibre_dateacceptation,fibre_dateouverture,fibre_datecommercialisation,cable_referencePrise,cable_numeroVoie,cable_voie,cable_complementVoie,cable_batiment,cable_escalier,cable_etage,cable_ville,cable_codeRivoli,cable_codePostal,cable_codeInsee,wttx_cohesionNumerique,wttx_attCohesionNumerique,typedocIdent,iddocIdent,checkStatus,opMkt,codeDistributeur,referencePm,upd_session){

      this.loading = true;
      
      contratService.create(site,domaine,civilite,nom,prenom,dateNaissance,adresse, adresseComplement, codePostal,ville,contactMail,iban, bic,titulaireIban,idOffre,serviceType,latitude,longitude,infrastructure,referenceAdresse,referenceImmeuble,infoRue,infoBatiment,infoEscalier,infoEtage,infoVille,infoCodePostal,contactMobile, contactFixe,listeIdOption,numero,rio,referencePrise,numeroRue,complementRue,porte,ensemble,codeInsee,idMobile,listeIdAccessoire,doccli_id,conservNum,codevendeur,offreChoisie,optionsChoisies,souscriptionId,id_eligibilite,libelleAdresse,fibre_numeroRue,fibre_typeVoie,fibre_rue,fibre_complementRue,fibre_ville,fibre_codePostal,fibre_codeInsee,fibre_dateacceptation,fibre_dateouverture,fibre_datecommercialisation,cable_referencePrise,cable_numeroVoie,cable_voie,cable_complementVoie,cable_batiment,cable_escalier,cable_etage,cable_ville,cable_codeRivoli,cable_codePostal,cable_codeInsee,wttx_cohesionNumerique,wttx_attCohesionNumerique,typedocIdent,iddocIdent,checkStatus,opMkt,codeDistributeur,referencePm,upd_session).then(res2 => { 
                this.loading = false;
                  if(res2){
                    if (res2.err !='error') {
                      const data2 = res2.params;
                    
                      this.$globalService.setSessionSouscription('resultCreateContrat',data2);
                      this.$router.push({name: 'Signature'});
                                
                    }else{
                      this.$dialog.error({
                        text: res2.err_msg,
                        title: 'Erreur',
                        persistent: false,
                        actions: {
                          false: 'Fermer'
                        }
                      })
                    
                    }
                  }
                }).catch(error=>{
                    this.loading = false;
                    this.$dialog.notify.error(this.$root.errorMessage, {
                              position: 'bottom-right',
                              timeout: 5000
                            })
                  return error;
                })
    }
  }
};
</script>

<style>
/* .v-card__title{
    color:var(--v-secondary-base);
    font-size: 1.3rem !important;
    font-weight:bold;
} */
#reponse .sel {
  background-color: var(--v-primary-base);
  color: white;
}
.poursuivre{
  background-image: linear-gradient(to right,var(--v-violet-base) 0,var(--v-rubine-base) 100%);
  color:white !important;
}

.v-progress-circular {
margin: 0.5rem;
}
</style>